import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMailSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.79126 0H27.78C29.8787 0 31.5712 1.70379 31.5712 3.79124V20.2088C31.5712 22.3075 29.8674 24 27.78 24H3.79126C1.69253 24 0 22.2962 0 20.2088V3.79124C0 1.69251 1.70381 0 3.79126 0ZM27.78 21.4612C28.4796 21.4612 29.0437 20.897 29.0437 20.1975V3.77995C29.0437 3.08037 28.4796 2.5162 27.78 2.5162H3.79126C3.09168 2.5162 2.52749 3.08037 2.52749 3.77995V20.1975C2.52749 20.897 3.09168 21.4612 3.79126 21.4612H27.78Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0437 20.1975C29.0437 20.897 28.4796 21.4612 27.78 21.4612H3.79126C3.09168 21.4612 2.52749 20.897 2.52749 20.1975V3.77995C2.52749 3.08037 3.09168 2.5162 3.79126 2.5162H27.78C28.4796 2.5162 29.0437 3.08037 29.0437 3.77995V20.1975ZM27.1255 6.49927C27.4189 6.17205 27.3963 5.66432 27.0691 5.35966V5.34837C26.7419 5.055 26.2341 5.07755 25.9295 5.40477L18.11 13.9577C18.0649 14.0141 18.0085 14.0592 17.952 14.1156C16.677 15.3117 14.6798 15.2327 13.4951 13.9577L5.66431 5.39351C5.35965 5.05501 4.8519 5.03242 4.52468 5.33708C4.18617 5.64173 4.1636 6.1495 4.46826 6.47672L10.2116 12.7503L4.98731 17.4217C4.6488 17.7151 4.62624 18.2228 4.91961 18.5613C5.21298 18.8998 5.73201 18.9224 6.05924 18.629L11.2948 13.9464L12.299 15.0409C13.2243 16.0564 14.4655 16.6093 15.7969 16.6093C17.1284 16.6093 18.3695 16.0564 19.2948 15.0409L20.2426 14.0028L25.4217 18.6516H25.4443C25.7828 18.945 26.2906 18.9111 26.5839 18.5726C26.8773 18.2341 26.8434 17.7264 26.5049 17.433L21.3484 12.818L27.1255 6.49927Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMailSolid;
